/******************************************************************************************
 *	Customer Details Controller
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.customerDetails', [
      'app.widgets.products.product-all-usage',
      'binky.core.migration',
      'binky.core.product.consumable'
    ])
    .controller('CustomerDetailsController', customerDetailsController);
  /* @ngInject */
  function customerDetailsController(
    _,
    $log,
    $scope,
    $stateParams,
    $state,
    $translate,
    $filter,
    $q,
    AddCustomerModal,
    ALERT_MODAL_TYPES,
    AlertModal,
    BreadcrumbsMenu,
    CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY,
    ConsumableSummarizationList,
    ConsumableUsageModal,
    CreatePaModal,
    CurtainNotifications,
    Customer,
    CustomerLoyaltyPrograms,
    CustomerNotifications,
    CustomerOrderHistoryConvertor,
    CustomerReminderModal,
    CustomerRenewalQuote,
    CUSTOMER_SEGMENT,
    CustomerSegments,
    CustomersListSnapshot,
    DemoMode,
    DeviceLicensingEligibility,
    downloadUtils,
    feature,
    Languages,
    LicenseDelegationDetailModal,
    LicenseSummaryUtility,
    locale,
    LoyaltyMembershipModal,
    MigrationList,
    MIGRATION_STATUS,
    MIGRATION_TYPE,
    moment,
    NewCancelPaModal,
    Offers,
    PaStatus,
    PurchaseDetailsModal,
    ProductsWithSameOrderNumberModal,
    ProductsWithSamePurchaseAuthModal,
    RcProduct,
    RcProductList,
    RENEWAL_ORDER,
    RenewalQuoteUtility,
    SelectedCustomer,
    SelectTeamMemberModal,
    SessionStorage,
    Settings,
    SspList,
    STORAGE_AVAILABLE,
    User,
    Utility,
    YesNoModal
  ) {
    // Use extended term string instead of customer-selected
    // When turned on, this allows us to hide the extend renewal feature for LARWs
    $scope.hideExtendRenewalWindow = feature.isEnabled('hide_extend_renewal');
    $scope.hide3YCDateChange = feature.isEnabled('temp_hide_date_change');

    // Consumption usage available. False here; will be set to true if there's usage data available
    $scope.consumableUsageDataAvailable = false;
    $scope.fetchingConsumptionData = false;

    //Controls visibility of content area
    $scope.noData = true;
    $scope.productsDataLoaded = false;

    // Set up variables for the display of renewal quotes
    $scope.displayRenewalQuote = false;
    $scope.quoteLoading = true;
    $scope.quoteError = false;

    // Set to false, until offers are fetched.
    $scope.hasValidTeamOffers = false;
    $scope.hasValidEnterpriseOffers = false;

    // Track if a customer has either kind of device license
    $scope.customerHasSharedDeviceLicenses = false;
    $scope.customerHasLegacyDeviceLicenses = false;

    $scope.customerSupportUrl = Utility.adobeGoUrl('contact_reseller_support');

    var customerID = $stateParams.customerID;
    $log.info('%cCustomer ID ::', 'font-weight:bold;color:#009966;', customerID);

    //Expose PaStatus methods to view
    $scope.PaStatus = PaStatus;

    //Set initial customer data from Customer List table
    //It will be overwritten after the server responds with customer information
    //The if-check is in case the URL id is changed by hand in which case the SelectedCustomer data no longer applies
    //or when the customer details page is the entry point in the app (e.g. copy-paste or link)
    if (SelectedCustomer.get() && SelectedCustomer.get().id === customerID) {
      $scope.customer = {
        details: SelectedCustomer.get()
      };
    }

    //Remembers sellable offers returned from server for use in the Create PA modal.
    //Also contains other data about the customer relevant to the Create PA modal.
    var sellableOffers;

    // Create a store for PAs that we've cancelled via the UI (and seen success on), so we can show them
    // as cancelled until the data updates on the backend. This obviously won't persist through a reload of the
    // page, but should at least offer a little leeway for the user to see the correct status while the changes
    // propagate through the backend.
    var localCancelledPaIds = [];

    var collapseCleansedData = function() {
      //Remove cleansed name if it is the same as name.
      if ($scope.customer.name === $scope.customer.cleansedName) {
        delete $scope.customer.cleansedName;
      }

      // Removed cleansed address if it is the same as address.
      // address type is BILLING, cleansedAddress type is CLEANSED so remove them.
      // All other fields should compare equal.
      if ($scope.customer.address) {
        $scope.customer.address.type = undefined;
      }
      if ($scope.customer.cleansedAddress) {
        $scope.customer.cleansedAddress.type = undefined;
      }

      if (angular.equals($scope.customer.address, $scope.customer.cleansedAddress)) {
        delete $scope.customer.cleansedAddress;
      }
    };

    var getCustomerOrganizationDetails = function() {
        $scope.loadingData = true;
        Customer.getCustomerOrganizationDetails(customerID)
          .then(function(responseData) {
            $scope.orgCountryCode = responseData.countryCode;
            $scope.loadingData = false;
          })
          .catch(function(response) {
            $scope.loadingData = false;
            $log.warn(response);
          });
    };

    //Get Customer Details
    var getCustomer = function() {
      //Loading spinner on
      $scope.loadingData = true;
      Customer.get(customerID)
        .then(function(responseData) {
          $scope.customer = responseData.details;
          //Determine if customer is eligible for device licensed products
          $scope.eligibleForDeviceLicenses = DeviceLicensingEligibility.evaluate($scope.customer);

          //Persist customer details so that the same data is not requested
          //if the user navigates to customer migration or renewal window extension views
          SelectedCustomer.set(responseData.details);

          //User has no PA history
          $scope.noPaHistory = !responseData.purchases;

          $scope.customer.anniversaryDateNotYetSet = _.isNull($scope.customer.anniversaryDate);

          let purchases = _.get(responseData, 'purchases');
          if (!_.isArray(purchases)) {
            purchases = [];
          }

          initPurchaseHistoryTableData(purchases);

          // Check to see if we have any local information saying a PA has been cancelled, but the back end
          // hasn't finished updating yet.
          updatePaStatusWithLocalCancelData(purchases);

          // See if there are any temporary PAs we should add to the list, unless the back end already has them.
          updatePaListWithTemporaryData(purchases);

          //Find overdue or pending PAs
          extractAlertsFromPurchaseHistory(purchases);

          //Products
          $scope.consumableSummarizationList = ConsumableSummarizationList.get({
            contract_id: $scope.customer.vipnumber,
            organization_id: customerID,
            summarize_by: CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY.LICENSE_ID
          });
          $scope.legacyProductList = _.get(responseData, 'products.productList');

          //Migrations and Products

          // Block PA Creation and Customer Editing if any migration is in progress
          $scope.customer.migrating = false;
          $scope.loadingData = true;

          $scope.customerProductList = RcProductList.get({contractId: $scope.customer.vipnumber, orgId: customerID, includeLegacyLSFields: true});
          let types = _.values(MIGRATION_TYPE);
          const migrations = MigrationList.get({
            orgId: customerID,
            types,
          });
          $q.all([migrations.$promise, $scope.customerProductList.$promise])
            .then(() => {
              // Migrations
              if (
                _.some(migrations.items, {status: MIGRATION_STATUS.MIGRATING}) || migrations.shouldForceBlockPACreation()
              ) {
                $scope.customer.migrating = true;
                $scope.customer.canCreatePA = false;
              }
              // Products
              if ($scope.customerProductList.items.length > 0) {
                $scope.consumableSummarizationList.$promise.then(() => {
                  $scope.fetchingConsumptionData = false;
                });
                $scope.productsDataLoaded = true;
                updatePaHistoryForConsumables(purchases);
                updateRenewalHistoryForConsumables(responseData.renewals);
              }
            })
            .catch(error => $log.error('error loading migrations or products', error))
            .finally(() => {
              $scope.loadingData = false;
              $scope.noData = false;
            });

          // License delegation summary
          LicenseSummaryUtility.createLicenseSummaryMetadata($scope.customer);

          //Inject PA statusLabel and initialize PA History
          initPaHistory(paHistoryInjectAdditionalData(purchases));

          //User has no Renewal history
          $scope.noRenewalHistory = !!responseData.renewals;

          //Initialize Renewal History
          initRenewalHistory(renewalHistoryInjectAdditionalData(responseData.renewals));

          const customerCountryCode = _.get($scope.customer.address, 'country.countryCode', '');

          if ($scope.orgCountryCode && customerCountryCode !== $scope.orgCountryCode) {
            const countryCode = $scope.orgCountryCode;

            $scope.customer.address.country['countryCode'] = countryCode;
            $scope.customer.cleansedAddress.country['countryCode'] = countryCode;

            $log.info('customer country code and org country code mismatch');
          }

          sellableOffers = {
            contractId: $scope.customer.vipnumber,
            customerCountryCode: _.get($scope.customer, 'address.country.countryCode', ''),
            //Add customer ID and device licensing eligibility to sellableOffers
            customerID: customerID,
            eligibleForDeviceLicenses: $scope.eligibleForDeviceLicenses,
            mode: determineDefaultPACreationMode($scope.customer),
            monthsToAnniversary: $scope.customer.monthsToAnniversary
          };

          // PA creation is blocked until the offers come back
          if ($scope.customer.canCreatePA) {
            $scope.offersList = {$promise: Offers.get($scope.customer)};
            $scope.offersList.$promise
              .then(function(responseData) {
                sellableOffers.offers = responseData;
                $scope.hasValidTeamOffers = sellableOffers.offers.teamOffers.length > 0;
                $scope.hasValidEnterpriseOffers = sellableOffers.offers.evipOffers.length > 0;
              })
              .catch(function(response) {
                $log.info('error loading offers: ' + response);
                $scope.failedToLoadOffers = true;
              });
          }

          collapseCleansedData();

          // Load and display the renewal summary section if the feature is active, and the customer is in either
          // Upcoming Renewals or Ready for Renewal segments
          $scope.displayRenewalQuote =
            $scope.customer.inRenewalWindow ||
            isFinite(parseInt($scope.customer.timeToUpcomingRenewal, 10));
          if ($scope.displayRenewalQuote) {
            $scope.quoteLoading = true;
            CustomerRenewalQuote.get($scope.customer.id)
              .then(function(responseData) {
                $scope.renewalQuote = RenewalQuoteUtility.createQuoteDataObjectFromResponse(
                  responseData
                );
                $scope.quoteError = false;
                $scope.quoteLoading = false;
              })
              .catch(function() {
                $scope.quoteLoading = false;
                $scope.quoteError = true;
              });
          }

          //Loyalty Programs
          //I'm currently addressing SELECT only.
          //Can't future-proof it now because we don't know what other loyalty programs will look like,
          //nor how the UI will behave when there's more than one.
          var loyaltyPrograms = new CustomerLoyaltyPrograms(responseData.loyaltyInfo);
          $scope.selectLoyaltyProgram = loyaltyPrograms[CustomerLoyaltyPrograms.SELECT];
          //Determine if the "View Details" link and Membership Status Modal be visible
          $scope.hasThreeYearCommit =
            $scope.selectLoyaltyProgram && $scope.selectLoyaltyProgram.hasThreeYearCommit();
          $scope.isEnrolledThreeYearCommit =
            $scope.selectLoyaltyProgram && $scope.selectLoyaltyProgram.isEnrolledThreeYearCommit();

          $scope.mockDemoModeEnabled = DemoMode.isMockEnabled();

          // update the hide extend renewal window so that it's only disabled for migrated or migrating customers
          $scope.hideExtendRenewalWindow =
            $scope.hideExtendRenewalWindow &&
            $scope.customer.oneConsoleMigrationStatus !== 'NOT_MIGRATED';

          // Set up the market sub-segment info if applicable
          determineSubsegmentLabel();
        })
        .catch(function(response) {
          $log.warn(response);

          if (response.status !== 0) {
            //status is 0 when call is aborted
            CurtainNotifications.show(
              CurtainNotifications.NOTICE,
              'customerDetails.notifications.invalidCustomer'
            );
            $scope.goBack();
          }
        });
    };


    //Fetch country code from org.
      getCustomerOrganizationDetails();

    //Fetch data on initial page load
    getCustomer();

    var determineDefaultPACreationMode = function(customer) {
      if (customer.entitledPlanTypes && customer.entitledPlanTypes.length === 1) {
        return customer.entitledPlanTypes[0];
      } else if (customer.requestedPlanType) {
        return customer.requestedPlanType;
      }
      return 'TEAM';
    };

    var findOfferById = function(offerId) {
      if (sellableOffers && sellableOffers.offers) {
        return $filter('filter')(sellableOffers.offers.allValidOffers, {
          offer_id: offerId
        });
      }
      return null;
    };

    var storeTemporaryPa = function(contractId, temporaryPa) {
      if (STORAGE_AVAILABLE) {
        var paMap = SessionStorage.get('temporaryPaMap') || {};
        if (!paMap[contractId]) {
          paMap[contractId] = {};
        }
        paMap[contractId][temporaryPa.poNumber] = temporaryPa;
        SessionStorage.set('temporaryPaMap', paMap);
      }
    };

    var getTemporaryPAs = function(contractId) {
      if (STORAGE_AVAILABLE) {
        var paMap = SessionStorage.get('temporaryPaMap');
        if (paMap) {
          return paMap[contractId];
        }
      }
      return null;
    };

    var removeTemporaryPa = function(contractId, paId) {
      if (STORAGE_AVAILABLE) {
        var paMap = SessionStorage.get('temporaryPaMap') || {};
        if (paMap[contractId] && paMap[contractId][paId]) {
          delete paMap[contractId][paId];
          if (_.keys(paMap[contractId]).length === 0) {
            delete paMap[contractId];
          }
          if (_.keys(paMap).length === 0) {
            SessionStorage.remove('temporaryPaMap');
          } else {
            SessionStorage.set('temporaryPaMap', paMap);
          }
        }
      }
    };

    var determineSubsegmentLabel = function() {
      // Set up the market sub-segment info if applicable
      var marketSubSegmentLabels = _.map($scope.customer.marketSubsegments, function(segment) {
        return $translate.instant(`customerDetails.detailsSection.marketSubSegment.${segment}`);
      });
      if (!_.isEmpty(marketSubSegmentLabels)) {
        $scope.customer.marketSubSegmentLabel = marketSubSegmentLabels.join(
          $translate.instant('customerDetails.detailsSection.marketSubSegment.separator') + ' '
        );
      }
    };

    const momentTodayPacificTime = moment()
    .tz('America/Los_Angeles');

    var getParseDate = function(fulfillByDate) {
      var parsedDate = null;
      var localDate = new Date(fulfillByDate);
      if (fulfillByDate && _.isString(fulfillByDate)) {
        if (localDate) {
          var dateArr = _.split(fulfillByDate, 'T');
          var yearMonthDay = _.split(dateArr[0], '-');
          if (yearMonthDay.length === 3) {
            var year = yearMonthDay[0];
            var month = parseInt(yearMonthDay[1], 10) - 1;
            var day = yearMonthDay[2];
            parsedDate = new Date(year, month, day);
          }
        }

        return parsedDate;
      }
    };

    // Pending if today is earlier or on fullfillByDate
    $scope.isPending = function(fulfillByDate){
      const parsedDate = getParseDate(fulfillByDate);
      return momentTodayPacificTime._d <= parsedDate;
    };

    // Overdue if today is greater than fullfillByDate
    $scope.isOverdue = function(fulfillByDate){
      const parsedDate = getParseDate(fulfillByDate);
      return momentTodayPacificTime._d > parsedDate;
    };

    /*=== Alerts ===*/
    var extractAlertsFromPurchaseHistory = function(data) {
      if (data && data.length) {
        var alerts = [];
        var userLicensedProducts;
        var deviceLicensedProducts;

          _.forEach(data, function(item) {
            // Find Team pending and overdue purchases.
            if (
              item.entitledPlanType &&
              ($scope.isPending(item.fulfillByDate) || $scope.isOverdue(item.fulfillByDate))
            ) {

              userLicensedProducts = [];
              deviceLicensedProducts = [];

              if (item.purchaseItems && item.purchaseItems.length) {
                _.forEach(item.purchaseItems, function(item) {
                  if (item.product && item.product.hasUserLicense()) {
                    userLicensedProducts.push(item);
                  } else if (item.product && item.product.hasDeviceLicense()) {
                    deviceLicensedProducts.push(item);
                  }
                });
              }

              //If either product list is empty, make it null so that the view
              //contains easier show/hide logic
              if (!userLicensedProducts.length) {
                userLicensedProducts = null;
              }
              if (!deviceLicensedProducts.length) {
                deviceLicensedProducts = null;
              }

              alerts.push({
                authorizationDate: item.authorizationDate || null,
                authorizedBy: item.authorizedBy || null,
                authorizationDurationMonths: item.authorizationDurationMonths || null,
                fulfillByDate: item.fulfillByDate,
                id: item.id,
                status: item.status,
                poNumber: item.poNumber,
                offeringCode: item.offeringCode,
                offeringName: item.offeringName,
                userLicensedProducts: userLicensedProducts,
                deviceLicensedProducts: deviceLicensedProducts,
                entitledPlanType: item.entitledPlanType
              });
            }
            if ($scope.isOverdue(item.status)) {
              $scope.hasOverdue = true;
            }
          });

        //Null if there are no alerts, same reason, easier for view
        if (!alerts.length) {
          alerts = null;
        }

        $scope.alerts = alerts;
      }
    };

    //Filter out items that have 0 unpaid quantity
    $scope.hasUnpaidQuantityFilter = function() {
      return function(item) {
        return item.unpaidQuantity > 0;
      };
    };

    /*=== Seat Authorization History ===*/

    // Check to see if we have any local information saying a PA has been cancelled, but the back end
    // hasn't finished updating yet. If so, update its status to one only valid locally for temporary status display.
    var updatePaStatusWithLocalCancelData = function(purchases) {
      if (purchases) {
        _.forEach(purchases, function(item) {
          // check to see if the PA is in our list of locally tracked cancelled PAs, and that its status
          // is still coming back as pending (notifications haven't been processed on the backend yet)
          if (_.includes(localCancelledPaIds, item.id) && PaStatus.isPending(item.status)) {
            item.status = 8;
            item.canBeDeleted = false;
          }
        });
      }
    };

    var updatePaListWithTemporaryData = function(purchases) {
      var temporaryPAs = getTemporaryPAs($scope.customer.vipnumber);
      if (temporaryPAs) {
        _.forEach(temporaryPAs, function(pa) {
          var match = $filter('filter')(purchases, {poNumber: pa.poNumber});
          if (match.length > 0) {
            // we are getting the PA from the backend, no need to store the temporary one anymore
            removeTemporaryPa($scope.customer.vipnumber, pa.poNumber);
          } else {
            // the PA isn't coming back yet, so we'll add ours to the beginning of the list
            _.forEach(pa.purchaseItems, function(item) {
              item.product = new RcProduct(item.productInfo, customerID, $scope.customer.vipnumber);
            });
            purchases.splice(0, 0, pa);
          }
        });
      }
    };

    //Adds the status label (name) for each seat authorization history item so that it can be searched by status name
    //as well as the offeringName for the same reason.
    //Server only sends the status identifier and offering code.
    var paHistoryInjectAdditionalData = function(data) {
      if (data) {
        _.forEach(data, function(item) {
          item.statusLabel = PaStatus.getTranslatedLabelByStatusId(item.status);
          item.offeringName = $translate.instant(`global.offerings.${item.offeringCode}`);

          var alias;
          if (item.authorizedByType === 'PRIOR_RESELLER') {
            alias = _.split(
              $translate.instant('customerDetails.paHistorySection.priorReseller'),
              ' '
            );

            if (locale.isSurnameFirstNameLocale()) {
              item.authorizedBy = {
                first_name: alias[1],
                last_name: alias[0]
              };
            } else {
              item.authorizedBy = {
                first_name: alias[0],
                last_name: alias[1]
              };
            }
          } else if (item.authorizedByType === 'LWS_ORDER') {
            if (locale.isSurnameFirstNameLocale()) {
              item.authorizedBy = {
                first_name: 'Order',
                last_name: 'LWS'
              };
            } else {
              item.authorizedBy = {
                first_name: 'LWS',
                last_name: 'Order'
              };
            }
          }
          // convert the order's entitledPlanType to an array, in normalizedPlanTypes, so
          // it can be used with the plan-type-icon directive (which expects an array).
          if (item.entitledPlanType) {
            item.normalizedPlanTypes = [item.entitledPlanType];
          }
        });
      }
      return data;
    };

    //Add offeringName for each renewal history item so it's searchable.
    var renewalHistoryInjectAdditionalData = function(data) {
      if (data) {
        _.forEach(data, function(item) {
          item.offeringName = $translate.instant(`global.offerings.${item.offeringCode}`);
          // convert the renewal's entitledPlanType to an array, in normalizedPlanTypes, so
          // it can be used with the plan-type-icon directive (which expects an array).
          if (item.entitledPlanType) {
            item.normalizedPlanTypes = [item.entitledPlanType];
          } else if (item.planTypes) {
            item.normalizedPlanTypes = item.planTypes;
            // we'll need an entitledPlanType for the detail dialog.
            // If we discover that renewal orders can have more than one type, we'll need to
            // refactor the purchase details modal to show 2 sections (one for Enterprise, one for Team).
            item.entitledPlanType = item.planTypes[0];
          }
          if (item.orderType) {
            // set up status labels for return vs renewal
            item.statusLabel = $translate.instant(
              item.orderType === RENEWAL_ORDER.STATUS.RETURN
                ? 'customerDetails.renewalHistorySection.status.returned'
                : 'customerDetails.renewalHistorySection.status.renewed'
            );
            // for return orders, we want to display the original order's PO number, but we want to keep
            // the return order's PO number around as well.
            if (item.orderType === RENEWAL_ORDER.STATUS.RETURN) {
              item.returnPoNumber = item.poNumber;
              if (item.originalOrder) {
                item.poNumber = item.originalOrder;
              }
            }
          }
        });
      }
      return data;
    };

    $scope.newPAHistoryTable = true;

    $scope.orderHistoryTableResponse = [];
    $scope.orderHistoryWithSameOrderNumbers = [];
    $scope.orderHistoryResponse = null;
    $scope.productOrderNumbers = [];
    $scope.productsWithSameOrderNumberModalData = [];
    $scope.productsWithSamePurchaseAuthModalData = [];
    $scope.paHistoryTableData = [];
    $scope.paHistoryTableItems = [];

    $scope.showPAHistoryTable = function() {
      $scope.orderHistoryTable = false;
      $scope.newPAHistoryTable = true;
    };

    var newPAHistoryList;
    var refreshNewPAHistory = function(options) {
      $scope.newPAHistory = newPAHistoryList.get(options);
    };

    var initNewPAHistory = function(data) {
        newPAHistoryList = new SspList(data, {
        itemsPerPage: Settings.itemsPerPage.seatHistory,
        searchFields: [
          'poNumber',
          'statusLabel',
          'authorizedBy.first_name',
          'authorizedBy.last_name',
          'authorizedBy.email'
        ],
        minSearchLength: Languages.minSearchLength()
      });

      refreshNewPAHistory({
        page: 1,
        sortBy: 'authorizationDate',
        sortDirection: 'desc'
      });
    };

    function initPurchaseHistoryTableData(purchases) {
      $scope.paHistoryTableResponse = purchases;
      _.forEach($scope.paHistoryTableResponse, (item) => {
        if (!_.includes($scope.paHistoryTableItems, item.poNumber)) {
          $scope.paHistoryTableItems.push(item.poNumber);
          const statusLabel = PaStatus.getTranslatedLabelByStatusId(item.status);
          item.statusLabel = statusLabel;
          $scope.paHistoryTableData.push(item);
        }
      });
      initNewPAHistory($scope.paHistoryTableResponse);
    }

    $scope.showProductsWithSamePurchaseAuthModal = function(item) {
      const poNumber = item.poNumber;
      if (item.salesAqoIds === null) {
        var data = {
          poNumber,
          currentItem: item,
          productsWithSameOrderNumberModalData: null
        };

        ProductsWithSamePurchaseAuthModal.create(data);
      } else {
        const saleAqoIds = item.salesAqoIds.join(",");
        Customer.getCustomersPASalesAQO(customerID, saleAqoIds)
          .then(function(responseData) {
            $scope.loadingData = false;

            var data = {
              poNumber,
              currentItem: item,
              productsWithSameOrderNumberModalData: responseData
            };

            ProductsWithSamePurchaseAuthModal.create(data);
          })
          .catch(function(response) {
            $log.warn(response);
            $scope.loadingData = true;
            $scope.orderHistoryTableResponse = null;
          });
      }
    };

    initPurchaseHistoryTableData();

    $scope.showProductsWithSameOrderNumberModal = function(orderNumber) {
      $scope.productsWithSameOrderNumberModalData = _.filter($scope.orderHistoryResponse, (item) =>
        item.orderNumber === orderNumber && item);

      var data = {
        orderNumber,
        productsWithSameOrderNumberModalData: $scope.productsWithSameOrderNumberModalData || null,
      };

      ProductsWithSameOrderNumberModal.create(data);
    };

    var orderHistoryList;
    var refreshOrderHistory = function(options) {
      $scope.orderHistory = orderHistoryList.get(options);
    };

    var initOrderHistory = function(data) {
      orderHistoryList = new SspList(data, {
        itemsPerPage: Settings.itemsPerPage.seatHistory,
        searchFields: [
          'orderNumber',
          'orderType',
          'poNumber',
          'unitOfMeasure'
        ],
        minSearchLength: Languages.minSearchLength()
      });

      refreshOrderHistory({
        page: 1,
        sortBy: 'orderDate',
        sortDirection: 'desc'
      });
    };

    function rawOrderHistoryData(data) {
      $scope.orderHistoryResponse = JSON.parse(JSON.stringify({payLoad: data})).payLoad;
    }

    function getOrderHistoryData() {
      if ($scope.orderHistoryResponse === null) {
        $scope.loadingData = true;
        Customer.getCustomersOrderHistory(customerID)
          .then(function(responseData) {
            rawOrderHistoryData(responseData);
            const tempOrderTableResponse = [];
            const tempSameOrderNumbers = [];
            $scope.loadingData = false;

            _.forEach(responseData, item => {
              if (!_.includes($scope.productOrderNumbers, item.orderNumber)) {
                $scope.productOrderNumbers.push(item.orderNumber);
                tempOrderTableResponse.push(item);
              } else {
                tempSameOrderNumbers.push(item);
              }
            });

            const orderHistoryTableResponseData = _.map(tempOrderTableResponse, (item) => {
              let unitOfMeasure = [];
              let quantity = 0;
              _.forEach(tempSameOrderNumbers, (orderItem) => {
                quantity = item.orderNumber === orderItem.orderNumber
                  ? quantity + orderItem.quantity
                  : quantity;

                if(item.orderNumber === orderItem.orderNumber){
                  unitOfMeasure.push(orderItem.unitOfMeasure);
                }
              });
              unitOfMeasure.push(item.unitOfMeasure);
              unitOfMeasure = _.uniq(unitOfMeasure);
              item.unitOfMeasure = unitOfMeasure.toString();
              item.quantity += quantity;
              return item;
            });

            initOrderHistory(orderHistoryTableResponseData);
          })
          .catch(function(response) {
            $log.warn(response);
            $scope.loadingData = true;
            $scope.orderHistoryTableResponse = null;
          });
      }
    }

    $scope.showOrderHistoryTable = function() {
      $scope.orderHistoryTable = true;
      $scope.newPAHistoryTable = false;
    };

    getOrderHistoryData();

    var paHistoryDataList;
    var refreshPaHistory = function(options) {
      $scope.paHistory = paHistoryDataList.get(options);
    };
    var initPaHistory = function(data) {
      paHistoryDataList = new SspList(data, {
        itemsPerPage: Settings.itemsPerPage.seatHistory,
        searchFields: [
          'offeringName',
          'poNumber',
          'statusLabel',
          'authorizedBy.first_name',
          'authorizedBy.last_name',
          'authorizedBy.email'
        ],
        minSearchLength: Languages.minSearchLength()
      });

      refreshPaHistory({
        page: 1,
        sortBy: 'authorizationDate',
        sortDirection: 'desc'
      });
    };

    //Pagination
    $scope.paHistoryPrevPage = function() {
      var page = $scope.paHistory.pagination.currentPage - 1;
      refreshPaHistory({page: page});
    };
    $scope.paHistoryNextPage = function() {
      var page = $scope.paHistory.pagination.currentPage + 1;
      refreshPaHistory({page: page});
    };

    //Sorting
    $scope.paHistorySort = function(column, serverColumns, isNumeric) {
      refreshPaHistory({sortBy: column, sortNumeric: isNumeric});
    };

    //Search
    $scope.paHistorySearch = function(query) {
      refreshPaHistory({query: query});
    };
    $scope.paHistoryClearSearch = function() {
      paHistoryDataList.clearSearch();
      refreshPaHistory();
    };

    $scope.clearTableSearch = function() {
      orderHistoryList.clearSearch();
      refreshOrderHistory();
    };

    //Order Pagination
    $scope.orderHistoryPrevPage = function() {
      var page = $scope.orderHistory.pagination.currentPage - 1;
      refreshOrderHistory({page: page});
    };
    $scope.orderHistoryNextPage = function() {
      var page = $scope.orderHistory.pagination.currentPage + 1;
      refreshOrderHistory({page: page});
    };

    //Order Sorting
    $scope.orderHistorySort = function(column, serverColumns, isNumeric) {
      refreshOrderHistory({sortBy: column, sortNumeric: isNumeric});
    };

    //Order Search
    $scope.searchTable = function(query) {
      refreshOrderHistory({query: query});
    };

    $scope.clearPATableSearch = function() {
      newPAHistoryList.clearSearch();
      refreshNewPAHistory();
    };

    //PA Pagination
    $scope.newPAHistoryPrevPage = function() {
      var page = $scope.newPAHistory.pagination.currentPage - 1;
      refreshNewPAHistory({page: page});
    };
    $scope.newPAHistoryNextPage = function() {
      var page = $scope.newPAHistory.pagination.currentPage + 1;
      refreshNewPAHistory({page: page});
    };

    //PA Sorting
    $scope.newPAHistorySort = function(column, serverColumns, isNumeric) {
      refreshNewPAHistory({sortBy: column, sortNumeric: isNumeric});
    };

    //PA Search
    $scope.newPASearchTable = function(query) {
      refreshNewPAHistory({query: query});
    };

    var updatePaHistoryForConsumables = function(purchaseData) {
      _.forEach(purchaseData, item => {
        item.consumableQuantity = 0;
        // only add the consumable information if there's only one purchase item. We don't want to show
        // consumable count and units in the table if the purchase is mixed in with other license types.
        //if (consumableItem && item.purchaseItems.length === 1) {
        if (
          _.every(item.purchaseItems, purchaseItem =>
            _.invoke(purchaseItem, 'product.isConsumptionBasedLicense')
          )
        ) {
          const quantities = _.map(item.purchaseItems, consumableItem => {
            const consumableCap = _.parseInt(consumableItem.product.getConsumableCap());
            if (_.isInteger(consumableCap) && _.isInteger(consumableItem.quantity)) {
              return consumableItem.quantity * consumableCap;
            }
          });
          item.consumableQuantity = _.sum(quantities);
          const itemProduct = _.get(item, 'purchaseItems[0].product');
          if (itemProduct) {
            item.consumableUnits = itemProduct.getConsumableUnitsForQuantity(
              item.consumableQuantity
            );
          }
          // If all the consumables purchased in this PA are ON_DEMAND, we shouldn't show duration.
          if (
            _.every(item.purchaseItems, purchaseItem => purchaseItem.product.isOnDemandConsumable())
          ) {
            item.authorizationDurationMonths = null;
          }
        }
      });
      if (paHistoryDataList) {
        paHistoryDataList.changeDataset(purchaseData);
        refreshPaHistory();
      }
    };

    /*=== Renewal History ===*/
    var renewalHistoryDataList;
    var refreshRenewalHistory = function(options) {
      $scope.renewalHistory = renewalHistoryDataList.get(options);
    };
    var initRenewalHistory = function(data) {
      renewalHistoryDataList = new SspList(data, {
        itemsPerPage: Settings.itemsPerPage.seatHistory,
        searchFields: ['offeringName', 'poNumber', 'statusLabel'],
        minSearchLength: Languages.minSearchLength()
      });

      refreshRenewalHistory({
        page: 1,
        sortBy: 'orderDate',
        sortDirection: 'desc'
      });
    };

    //Pagination
    $scope.renewalHistoryPrevPage = function() {
      var page = $scope.renewalHistory.pagination.currentPage - 1;
      refreshRenewalHistory({page: page});
    };
    $scope.renewalHistoryNextPage = function() {
      var page = $scope.renewalHistory.pagination.currentPage + 1;
      refreshRenewalHistory({page: page});
    };

    //Sorting
    $scope.renewalHistorySort = function(column, serverColumns, isNumeric) {
      refreshRenewalHistory({sortBy: column, sortNumeric: isNumeric});
    };

    //Search
    $scope.renewalHistorySearch = function(query) {
      refreshRenewalHistory({query: query});
    };
    $scope.renewalHistoryClearSearch = function() {
      renewalHistoryDataList.clearSearch();
      refreshRenewalHistory();
    };

    var updateRenewalHistoryForConsumables = function(renewalData) {
      _.forEach(renewalData, item => {
        item.consumableQuantity = 0;
        const consumableItem = _.find(item.renewalItems, renewalItem =>
          _.invoke(renewalItem, 'product.isConsumptionBasedLicense')
        );
        if (consumableItem) {
          // TO DO: update per purchase ID, not for whole entitlement
          const consumableCap = _.parseInt(consumableItem.product.getConsumableCap());
          if (_.isInteger(consumableCap) && _.isInteger(consumableItem.quantity)) {
            item.consumableQuantity = consumableItem.quantity * consumableCap;
          }
          item.consumableUnits = consumableItem.product.getConsumableUnitsForQuantity(
            item.consumableQuantity
          );
        }
      });
      if (renewalHistoryDataList) {
        renewalHistoryDataList.changeDataset(renewalData || []);
        refreshRenewalHistory();
      }
    };

    /*=== Create Purchase Authorization ===*/
    $scope.showCreatePAModal = function(event, mode) {
      event.preventDefault();

      $scope.onCreatePurchaseAuth(mode);
    };

    $scope.onCreatePurchaseAuth = function(mode) {
      if (
        Boolean(feature.isEnabled('temp_disable_for_russia') &&
        $scope.customer.address.country.countryCode === 'RU') &&
          Boolean(feature.isEnabled('temp_disable_for_belarus') &&
          $scope.customer.address.country.countryCode === 'BY')
      ) {
        CurtainNotifications.show(CurtainNotifications.ERROR, 'customerDetails.notifications.restrictedCustomer');
        return;
      }


      if (User.isResellerMember() || User.isResellerAdmin()) {
        if (mode) {
          sellableOffers.mode = mode;
          sellableOffers.marketSegment = $scope.customer.marketSegment;
        }
        CreatePaModal.create(sellableOffers).then(function(data) {
          // If modal wasn't cancelled (closed without submit), fetch updated customer details
          if (data && !data.cancelled) {
            var responsePoNumber = _.get(
              data,
              'response.billing_summary.contract_details.customer_po_number'
            );
            if (responsePoNumber) {
              var temporaryPA = {
                authorizationDate: new Date(),
                canBeDeleted: false,
                poNumber: responsePoNumber,
                purchaseItems: [],
                status: 9
              };
              if (data.type) {
                temporaryPA.entitledPlanType = data.type;
              }
              var seatCount = 0;
              _.forEach(data.response.billing_summary.billable_items, function(item) {
                var offers = findOfferById(item.offer_id);
                if (offers && offers.length > 0) {
                  temporaryPA.purchaseItems.push({
                    productInfo: {
                      licenseType: 'STANDARD',
                      productCode: offers[0].product_code,
                      productName:
                        offers[0].merchandising && offers[0].merchandising.copy
                          ? offers[0].merchandising.copy.short_name
                          : ''
                    },
                    quantity: item.quantity,
                    unpaidQuantity: item.quantity
                  });
                }
                seatCount += item.quantity;
              });
              temporaryPA.seatCount = seatCount;
              // store the temporary PA by contract Id
              storeTemporaryPa($scope.customer.vipnumber, temporaryPA);
            }
            //New PA created successfully, refresh data
            if ($scope.customerProductList) {
              $scope.customerProductList.refresh();
            }
            getCustomer();
          }
        });
      }
    };

    /*=== Purchase Details Modal ===*/
    $scope.showPurchaseDetailsModal = function(event, item) {
      event.preventDefault();

      //Normalize data passed to the modal component so that it works with both PAs and POs
      var products = item.purchaseItems || item.renewalItems;
      var userLicensedProducts = [];
      var deviceLicensedProducts = [];
      var consumableLicensedProducts = [];

      if (products && products.length) {
        //Separate products based on license type and
        //compute total paid and total unpaid seats
        _.forEach(products, function(item) {
          //Separate by license type
          if (item.product && item.product.isConsumptionBasedLicense()) {
            const consumableCap = _.parseInt(item.product.getConsumableCap());
            if (_.isInteger(consumableCap) && _.isInteger(item.quantity)) {
              item.consumableQuantity = item.quantity * consumableCap;
            } else {
              item.consumableQuantity = item.product.getConsumableCap();
            }
            item.units = item.product.getConsumableUnitsForQuantity(item.consumableQuantity);
            consumableLicensedProducts.push(item);
          } else if (item.product && item.product.hasUserLicense()) {
            userLicensedProducts.push(item);
          } else if (
            item.product &&
            (item.product.hasDeviceLicense() || item.product.isSharedDeviceLicense())
          ) {
            //Show device licenses in PA details regardless of customer device elgibility
            //because even if he isn't eligible, he might have paid for such SKUs.
            deviceLicensedProducts.push(item);
          }
        });
      } else if (
        item.userLicensedProducts ||
        item.deviceLicensedProducts ||
        item.consumableLicensedProducts
      ) {
        // The item we were passed was already split out into sections; use them.
        userLicensedProducts = item.userLicensedProducts || [];
        deviceLicensedProducts = item.deviceLicensedProducts || [];
        consumableLicensedProducts = item.consumableLicensedProducts || [];
      }

      //If either product list is empty, make it null so that the view
      //contains easier show/hide logic
      if (!userLicensedProducts.length) {
        userLicensedProducts = null;
      }
      if (!deviceLicensedProducts.length) {
        deviceLicensedProducts = null;
      }
      if (!consumableLicensedProducts.length) {
        consumableLicensedProducts = null;
      }

      //Data to be set on modal scope
      var data = {
        poNumber: item.poNumber,
        returnPoNumber: item.returnPoNumber || null,
        anniversaryDateNotYetSet: $scope.customer.anniversaryDateNotYetSet,
        authorizationDate: item.authorizationDate || null,
        authorizedBy: item.authorizedBy || null,
        authorizationDurationMonths: item.authorizationDurationMonths || null,
        status: _.isNil(item.status) ? null : item.status,
        statusLabel: item.statusLabel || null,
        statusDate: item.statusDate || null,
        offeringCode: item.offeringCode,
        orderDate: item.orderDate || null,
        orderType: item.orderType || null,
        entitledPlanType: item.entitledPlanType,
        seatCount: item.seatCount,
        userLicensedProducts: userLicensedProducts,
        deviceLicensedProducts: deviceLicensedProducts,
        consumableLicensedProducts: consumableLicensedProducts,
        eligibleForDeviceLicenses: $scope.eligibleForDeviceLicenses
      };

      PurchaseDetailsModal.create(data);
    };

    /*=== New Cancel PA ===*/
    $scope.newCancelPA = function(event, item) {
      event.preventDefault();

      if (User.isResellerMember() || User.isResellerAdmin() || User.isLicenseAdminReadWrite()) {
        var cancellableItems= [];
        _.forEach(item.purchaseItems, function(purchase) {
          var purchaseItem = {
            'acquired-offer-id': purchase.id,
            'offer-id': purchase.product.offerId,
            quantity: purchase.quantity,
            'cancellation-reason': 'ADMIN_CANCELLED'
          };
          cancellableItems.push(purchaseItem);
        });

        var data = {
          customerID: $scope.customer.id,
          contractId: $scope.customer.vipnumber,
          marketSegment: $scope.customer.marketSegment,
          customerCountry: _.get($scope.customer, 'address.country.countryCode', ''),
          cancellableItems,
        };

        NewCancelPaModal.create(data).then(function(result) {
          // If modal wasn't cancelled (closed without submit), fetch updated customer details
          if (result && !result.cancelled) {
            // save locally for mitigation of backend delays
            localCancelledPaIds.push(item.id);
            //PA cancelled, refresh data
            getCustomer();
          }
        });
      }
    };


    /*=== Show Select Team Member Modal ===*/
    var salesRepBeforeUpdate;
    $scope.showSelectTeamMemberModal = function(event) {
      event.preventDefault();

      if (User.isResellerAdmin() || User.isLicenseAdminReadWrite()) {
        //Remove current sales rep from list
        var data = {
          excludedUserIDs: [$scope.customer.managedBy.userId]
        };

        SelectTeamMemberModal.create(data).then(function(data) {
          //If modal wasn't cancelled (closed without submit)
          if (data && !data.cancelled) {
            //Update customer to match selection, will be reset if update fails
            salesRepBeforeUpdate = $scope.customer.managedBy;
            $scope.customer.managedBy = data.teamMember;
            $scope.updatingSalesRep = true;

            Customer.updateSalesRep(customerID, data.teamMember.userId)
              .then(function() {
                $scope.updatingSalesRep = false;
              })
              .catch(function(response) {
                //Revert $scope.customer
                $scope.customer.managedBy = salesRepBeforeUpdate;
                salesRepBeforeUpdate = null;
                $scope.updatingSalesRep = false;

                CurtainNotifications.show(
                  CurtainNotifications.ERROR,
                  'customerDetails.notifications.changeSalesRepFailed'
                );
                $log.error('Failed to change the sale rep', response.data);
              });
          }
        });
      }
    };

    /*=== Show Loyalty Membership Modal ===*/
    $scope.showLoyaltyMembershipModal = function(event, allowDateChange) {
      event.preventDefault();

      if ($scope.hasThreeYearCommit) {
        //Data to be passed to modal $scope
        var data = {
          allowDateChange: allowDateChange,
          customerId: $scope.customer.id,
          loyaltyInfo: $scope.selectLoyaltyProgram
        };

        LoyaltyMembershipModal.create(data);
      }
    };

    /*=== Show License Delegation Detail Modal ===*/
    $scope.showLicenseDelegationDetailModal = function(products, type) {
      var data = {
        customerSegment: type === 'TEAM' ? CUSTOMER_SEGMENT.TEAM : CUSTOMER_SEGMENT.ENTERPRISE,
        products: products,
        consumableUsageDataAvailable: $scope.consumableUsageDataAvailable
      };
      LicenseDelegationDetailModal.create(data);
    };

    /*=== Show License Delegation Detail Modal ===*/
    $scope.showConsumableUsageModal = function(consolidatedProduct) {
      if (!_.isEmpty(consolidatedProduct.consumables)) {
        ConsumableUsageModal.create({
          product: consolidatedProduct
        });
      }
    };

    /*=== Download Order History As CSV ===*/
    $scope.downloadOrderHistoryAsCsv = function() {
      //Get data and then, from that, the CSV string
      var purchaseAuthorizations = paHistoryDataList.getOriginalDataset();
      var renewalOrders = renewalHistoryDataList.getOriginalDataset();
      var csvContent = CustomerOrderHistoryConvertor.getCsvContents(
        $scope.customer,
        purchaseAuthorizations,
        renewalOrders,
        $scope.orderHistoryResponse,
        $scope.selectLoyaltyProgram,
        $scope.renewalQuote,
        $scope.products,
        $scope.enterpriseProducts
      );

      // Trigger file download
      downloadUtils.downloadExportData(csvContent, 'customer-details.csv');
    };

    /*=== Refresh Customer Data (LARW-Refresh-Customer feature) ===*/
    var customerDataRefreshInProgress = false;
    $scope.refreshCustomerData = function(event) {
      event.preventDefault();

      //If refreshing a customer isn't allowed yet, show a curtain-notification and return.
      if (!CustomerNotifications.canRefreshCustomer($scope.customer.id)) {
        CurtainNotifications.show(
          CurtainNotifications.NOTICE,
          'customerDetails.notifications.waitToSendRefreshCustomerNotification'
        );
        return;
      }

      if (!customerDataRefreshInProgress) {
        YesNoModal.create({
          title: 'customerDetails.refreshCustomerData.title',
          message: 'customerDetails.refreshCustomerData.message',
          yesButtonLabel: 'customerDetails.refreshCustomerData.yesButton',
          noButtonLabel: 'generic.buttons.cancel',
          type: ALERT_MODAL_TYPES.NOTICE
        }).then(function(data) {
          //If user clicked "yes-button"...
          if (data && !data.cancelled) {
            customerDataRefreshInProgress = true;
            $scope.loadingData = true; //Spinner: ON

            //Send the refresh customer notification, then re-fetch customer details.
            //If JIL finished updating the cache, new customer data will be visible.
            //Otherwise, same data will be received until cache update is finished.
            CustomerNotifications.refreshCustomer($scope.customer.id)
              .then(
                function() {
                  if ($scope.customerProductList) {
                    $scope.customerProductList.refresh();
                  }
                  getCustomer();
                },
                function(reason) {
                  $scope.loadingData = false; //Spinner: OFF
                  $log.warn(reason);
                }
              )
              .finally(function() {
                customerDataRefreshInProgress = false;
              });
          }
        });
      }
    };

    /*=== Edit Customer Modal ===*/
    $scope.showEditCustomerModal = function(customer) {
      if (User.isResellerMember() || User.isResellerAdmin() || User.isLicenseAdminReadWrite()) {
        var locals = {
          customer: customer
        };

        AddCustomerModal.create(locals).then(function(data) {
          // If the edited invite was already accepted, refresh the customer data.
          // Otherwise, if modal wasn't cancelled (closed without submit) update the existing customer
          if (data && !data.cancelled) {
            if (data.refreshCustomers) {
              getCustomer();
            } else {
              // Update customer data from the response
              const editedCustomer = _.has(data, 'response.details')
                ? _.get(data, 'response.details')
                : _.get(data, 'response');
              _.assign($scope.customer, editedCustomer);
              collapseCleansedData();
            }
          }
        });
      }
    };

    /*=== Send Reminder Modal ===*/
    $scope.sendReminder = function(event, customer) {
      event.preventDefault();

      var locals = {
        customer: {
          id: customer.id,
          email: _.get(customer, 'admin.email'),
          name: customer.name,
          lastInviteDate: customer.lastInviteDate,
          usadEnabled: !!customer.usadEnabled
        }
      };

      CustomerReminderModal.create(locals).then(function(data) {
        if (data && !data.cancelled) {
          // data.refreshCustomers is true in the rare case when a send reminder is attempted after a customer
          // already accepted an invitation. It's a rare case because it would mean the customer accepted
          // the invitation after the reseller representative loaded this detail page, but before the reminder was sent.
          if (data.refreshCustomers) {
            getCustomer();
          } else {
            if (!customer.admin) {
              customer.admin = {};
            }
            customer.admin.email = _.get(data, 'response.email');
            customer.lastInviteDate = _.get(data, 'response.lastInviteDate');
          }
        }
      });
    };

    /*=== Breadcrumbs ===*/
    //Update breadcrumbs path for Customers entry to point to last segment visited if available, otherwise All customers segment.
    //The default segment, Pending Invitations, doesn't point to Customer Details page, hence defaulting to All customers segment.
    var previousCustomerSegment =
      CustomersListSnapshot.getSegment() || CustomerSegments.getAllCustomersSegment().path;
    if (User.isLicenseAdmin()) {
      BreadcrumbsMenu.updateStateParams('licenseAdmin.impersonatedReseller.customers.segments', {
        segment: previousCustomerSegment
      });
    } else {
      BreadcrumbsMenu.updateStateParams('customers.segments', {
        segment: previousCustomerSegment
      });
    }

    //Go back to customer list
    $scope.goBack = function() {
      if (User.isLicenseAdmin()) {
        $state.go('licenseAdmin.impersonatedReseller.customers.segments', {
          segment: previousCustomerSegment
        });
      } else {
        $state.go('customers.segments', {segment: previousCustomerSegment});
      }
    };

    /*=== Clean-up ===*/
    $scope.$on('$destroy', function() {
      //Remove any modals if visible, otherwise navigation (via back / forward arrows) would preserve the modal over other views
      CreatePaModal.remove();
      PurchaseDetailsModal.remove();
      NewCancelPaModal.remove();
      AlertModal.remove();
      YesNoModal.remove();
    });
  }
})();
